import { Box } from '../../../../../../mads';
import { useViewjobOneGraphModel } from '../../../../context/ViewJobDataContext';
import { Banner } from '../Banner';
import { Logo } from '../Logo';

import React from 'react';
import { StyleSheet } from 'react-native';

// These Model interfaces will be replaced by types generated from GraphQL fragments.
interface CompanyImagesModel {
    logoUrl?: string;
    headerImageUrl?: string;
    logoImageOverlayLower: boolean;
    logoAltText: string;
}

export type BrandedHeaderProps = {
    companyImagesModel?: CompanyImagesModel;
};

/**
 * The top banner for the page showing branding information for the company, this will show the banner and an optional
 * logo if it is present.
 */
export const BrandedHeader = ({ companyImagesModel }: BrandedHeaderProps) => {
    if (!companyImagesModel) {
        return null;
    }

    const hasLogo = companyImagesModel.logoUrl && companyImagesModel.logoImageOverlayLower;

    return (
        <>
            {companyImagesModel.headerImageUrl && (
                <Banner
                    url={companyImagesModel.headerImageUrl}
                    altText={companyImagesModel.logoAltText}
                />
            )}

            {hasLogo ? (
                <Box sx={styles.logoPosition}>
                    <Logo
                        url={companyImagesModel.logoUrl!}
                        altText={companyImagesModel.logoAltText}
                        size={60}
                        hasShadow={true}
                        hasBorder={false}
                    />
                </Box>
            ) : (
                // add a bit of spacing if there is no logo
                <Box sx={styles.bannerOnlySpacing} />
            )}
        </>
    );
};

const styles = StyleSheet.create({
    // Used to shift the logo over the banner.
    logoPosition: {
        zIndex: 1,
        marginLeft: 16,
        bottom: 32,
        marginBottom: -24,
    },
    bannerOnlySpacing: {
        marginTop: 16,
    },
});

export interface OGWrappedBrandedHeaderProps {}

export function OGWrappedBrandedHeader({}: OGWrappedBrandedHeaderProps) {
    const ogModel = useViewjobOneGraphModel();

    if (ogModel == null || ogModel.employer?.companyImagesModel == null) {
        return null;
    }

    return <BrandedHeader companyImagesModel={ogModel.employer.companyImagesModel} />;
}
